import { ModalReducer } from "./interfaces";

export const setModalAreas = (areas: ModalReducer['areas']) => ({
	type: 'SET_MODAL_AREAS',
	payload: { areas },
});

export const clearModal = () => ({
	type: 'CLEAR_MODAL',
});